import {DG_axios} from "../../../../../custom/axios";

const BASE_URI =
    `/dogoo/employee-career-rest/v2.0/employee-careers`;


const BASE_EMPLOYEE_CAREER = "/dogoo/employee-career-rest/v2.0/employee-careers"

export const getEmployeeCurrentByEmployeeId = async (employeeId) => {

    const response = await DG_axios.get(BASE_EMPLOYEE_CAREER + "/employee-current/" + employeeId)
    return response?.data || []
}

export const searchEmployeesCareer = async (field, id) => {
    const response = await DG_axios.get(`${BASE_URI}/department-jobposition-jobtitle?field=${field}&id=${id}`, null)
    return response?.data || []
};

export const loadEmployeeCareersByDepartmentAndJobPositionAndJoinDateApi = async (departmentIds, jobPositionIds, joinDate, code, search) => {

    let buildQuery = `?`;

    if (!!code) {
        buildQuery += `employeeExternalReferanceCode=${code}&`
    }

    departmentIds?.forEach((id) => {
        buildQuery += `departmentIds=${id}&`
    })

    jobPositionIds?.forEach((id) => {
        buildQuery += `jobPositionIds=${id}&`
    })

    if (!!joinDate) {
        buildQuery += `joinDate=${joinDate}`
    }

    const response = await DG_axios.get(`${BASE_URI}/department-jobposition-jobtitle-joindate${buildQuery}`, {params: {search}});

    return response?.data || []
};
